import { render, staticRenderFns } from "./ticket-exa-table-item.vue?vue&type=template&id=547d9d0b&scoped=true&"
import script from "./ticket-exa-table-item.vue?vue&type=script&lang=js&"
export * from "./ticket-exa-table-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547d9d0b",
  null
  
)

export default component.exports